var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio',{staticClass:"jradio",class:{
    noLabel: _vm.noLabel,
  },attrs:{"label":_vm.label},model:{value:(_vm.radioModel),callback:function ($$v) {_vm.radioModel=$$v},expression:"radioModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }